import { defineSidebarConfig } from '~/helpers/_core/sidebar';

export default defineSidebarConfig(({ i18n, $aud }) => {
  return {
    allowSearch : true,
    items       : [
      /*
      {
        title    : i18n.t('sidebar.example'),
        icon     : 'mdi-view-dashboard',
        children : [
          {
            title : 'Meus cursos',
            grant : {
              aud         : $aud.cockpit,
              permissions : ['courses']
            },
            icon : 'mdi-view-dashboard',
            link : '/my-courses'
          }
        ]
      },
      {
        title : 'Central de notificações',
        grant : {
          aud         : $aud.cockpit,
          permissions : ['notifications', 'notifications.write']
        },
        icon : 'mdi-view-dashboard',
        link : '/notifications'
      }
      */
    ]
  };
});
